import store from '@/store'
import { ELoadingActions } from '@/store/loadingStore/LoadingStoreTypes'

export const setGlobalLoading = (isLoading: boolean) =>
    store.dispatch(isLoading ? ELoadingActions.IS_LOADING : ELoadingActions.NOT_IS_LOADING)
